import React, { useEffect, useState } from "react";
import { CreateContainer } from "./ContainerCreate";
import axios from "@dreamchimney/react-axios";
import { getSleeveComments } from "../../api/getComments";
import Skeleton from "react-loading-skeleton";
import { useUser } from "@dreamchimney/user-context";
import { postSleeveComment } from "~/api/getComments";

const SleeveCommentsContainer = (props) => {
  const { state: userState, dispatch } = useUser();

  const { data, loading, failure, render } = props;

  const [sleeveComments, setSleeveComments] = useState([]);
  const [userComment, setUserComment] = useState("");
  const [userCommentSaving, setUserCommentSaving] = useState(false);

  useEffect(() => {
    const sleeveId = props.sleeveId || 1;
    props.request(sleeveId);
  }, []);

  useEffect(() => {
    const results = (data && data.data) || [];
    const { comments = [] } = results;
    setSleeveComments(comments);
  }, [data]);

  const handleChange = (event) => {
    setUserComment(event.target.value);
  };
  const handleLogin = (event) => {
    // setUserComment(event.target.value);
    dispatch({ type: "signin_open" });
  };
  const handleRegister = (event) => {
    // setUserComment(event.target.value);
  };

  const postComment = async () => {
    const payload = {
      sleeve_id: props.sleeveId,
      user: { chimdir: userState.user.dir, platform: "dreamchimney" },
      comment: userComment.trim(),
    };

    if (userComment.trim() !== "") {
      const response = await postSleeveComment(axios, payload);
      setSleeveComments(response.data.comments);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    setUserCommentSaving(true);
    postComment();
    setUserCommentSaving(false);
    setUserComment("");
  };

  if (loading) {
    return <Skeleton count={3} />;
  }

  // const render = () => {

  // return render({ comments, loading, failure });
  return (
    <div>
      <ul className="list-unstyled comment-list">
        {sleeveComments.map((comment) => (
          <li key={comment.id}>
            <span className="author">
              <strong>{comment.user}</strong>
            </span>
            <div className="message">{comment.message}</div>
            <div className="date">({comment.date})</div>
          </li>
        ))}
      </ul>
      <h4>Add Your Comment</h4>

      {!userState.loggedin && (
        <div>
          <p>You must create an account or sign-in to add a comment.</p>
          <p>
            <button type="button" onClick={handleLogin} className="btn btn-primary">
              Login / Register
            </button>
          </p>
        </div>
      )}
      {userState.loggedin && (
        <form>
          <div className="comment-form">
            <strong>
              {userState.user.full_name} {userState.isChim && ` Chimney`}
            </strong>
          </div>
          <div>
            <textarea
              id="comment"
              name="comment"
              className="form-control"
              required="required"
              placeholder="Your comment..."
              value={userComment}
              onChange={handleChange}
              style={{ marginBottom: "10px" }}
            ></textarea>

            <button onClick={handleSubmit} type="button" disabled={userCommentSaving} className="btn btn-secondary btn-cmt">
              Submit
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default CreateContainer(getSleeveComments, SleeveCommentsContainer);
